export default (props = {}) => <svg width="14" height="14" viewBox="0 0 14 14" fill="none" xmlns="http://www.w3.org/2000/svg"{...props}>
<g id="Rating / FavoriteFill">
<path id="Vector" fill-rule="evenodd" clip-rule="evenodd" d="M2.24809 2.83958C0.80619 4.29235 0.806192 6.64776 2.24809 8.10053L5.91857 11.7987C6.51583 12.4004 7.48417 12.4004 8.08143 11.7987L11.7519 8.10053C13.1938 6.64776 13.1938 4.29235 11.7519 2.83958C10.4578 1.53571 8.44204 1.40207 7 2.43865C5.55796 1.40207 3.5422 1.53571 2.24809 2.83958Z" fill="white"/>
</g>
</svg>
